import React, { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Lock, CheckCircle2, ArrowLeft } from "lucide-react";
import { toast } from "sonner";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";

  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) { toast.error("Mindestens 8 Zeichen erforderlich"); return; }
    if (pw !== pw2) { toast.error("Passwörter stimmen nicht überein"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      setDone(true);
      toast.success("Passwort aktualisiert");
      setTimeout(() => navigate("/login"), 1500);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Fehler");
    } finally { setLoading(false); }
  };

  if (!token) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background p-8">
        <div className="prime-card p-6 max-w-sm text-center">
          <div className="font-display font-bold text-lg">Token fehlt</div>
          <p className="text-sm text-muted-foreground mt-2">Verwenden Sie den Link aus Ihrer E-Mail.</p>
          <Link to="/login" className="mt-4 inline-flex items-center gap-1 text-xs text-prime hover:underline">
            <ArrowLeft className="w-3 h-3" /> Zum Login
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-8">
      <div className="w-full max-w-sm">
        <div className="label-uppercase text-prime mb-3">Neues Passwort</div>
        <h2 className="font-display font-extrabold text-3xl tracking-tight mb-2">Passwort festlegen</h2>
        <p className="text-sm text-muted-foreground mb-8">Wählen Sie ein neues Passwort (mind. 8 Zeichen).</p>

        {!done ? (
          <form onSubmit={submit} className="space-y-5" data-testid="reset-form">
            <div>
              <Label className="label-uppercase text-muted-foreground">Neues Passwort</Label>
              <Input
                type="password" required value={pw} onChange={e => setPw(e.target.value)}
                className="h-11 mt-2" autoFocus minLength={8} data-testid="reset-pw"
              />
            </div>
            <div>
              <Label className="label-uppercase text-muted-foreground">Passwort wiederholen</Label>
              <Input
                type="password" required value={pw2} onChange={e => setPw2(e.target.value)}
                className="h-11 mt-2" minLength={8} data-testid="reset-pw2"
              />
            </div>
            <Button type="submit" disabled={loading} className="w-full h-11 btn-prime gap-2" data-testid="reset-submit">
              <Lock className="w-4 h-4" /> {loading ? "…" : "Passwort speichern"}
            </Button>
          </form>
        ) : (
          <div className="prime-card p-5 flex flex-col items-center text-center gap-3">
            <CheckCircle2 className="w-10 h-10 text-green-600" />
            <div className="font-medium">Passwort aktualisiert</div>
            <p className="text-xs text-muted-foreground">Sie werden zum Login weitergeleitet…</p>
          </div>
        )}
      </div>
    </div>
  );
}
